<template>
  <div class="groupSetting_main"  :class="{'cn':version == '1'}" v-show="!groupAddDev">
    <div class="cont_right">
      <div class="table_box">
        <div class="tr">
          <div class="th" style="width: 8rem;">{{ $t('App.groupSetting.text1') }}</div>
          <div class="th" style="width: 20rem;flex:1">{{ $t('App.groupSetting.text2') }}</div>
          <div class="th" style="width: 20rem;flex:1">{{ $t('App.groupSetting.text8') }}</div>
          <!-- <div class="th" style="width: 20rem;">{{ $t('App.groupSetting.text3') }}</div> -->
          <div class="th" style="width: 20rem;" v-if="inputType == 'edit'">{{ $t('App.groupSetting.text4') }}</div>
          <div class="th" style="width: 20rem;" v-if="inputType == 'edit'"></div>
          <div class="th_scrollbar"></div>
        </div>
        <div class="tr_td_box scrollbar_style">

          <div v-if="inputType != 'edit'">
            <div class="tr" :class="{'select':groupId==item.id}" v-for="(item, index) in groupList" :key="'tr_' + index" @dblclick="inputChangeFun(item,index)" @click="textChangeFun($event,item,index)">
              <div class="td" style="width: 8rem;">
                <span>{{ index + 1 }}.</span>
              </div>
              <div class="td" style="width: 20rem;flex:1;">
                <span >{{ item.name }}</span>
              </div>
              <div class="td" style="width: 20rem;flex:1;">
                <span v-if="item.lampNames">{{ item.lampNames.split(',')[0] }} <span @click.stop="viewLamp(item, index)" class="icon_x" v-if="item.lampNames.split(',').length>1"></span></span>
 
                <div class="lamp_list_bg" v-if="item.showLamp" @click.stop="item.showLamp = false"></div>
                <div class="lamp_list scrollbar_style" v-if="item.showLamp">
                  <div class="li" v-for="(name,i) in item.lampNames.split(',')" :key="i+'lanpName'">{{ name }}</div>
                </div>
                <span v-if="!item.lampNames"></span>
              </div>
              <!-- {{ item.lampIds }} -->
              <span v-if="!item.lampIds" style="position: absolute;font-size: 1rem;color: red;right: 1rem;bottom: 0rem;line-height: initial;">{{ $t('App.groupSetting.text5') }}</span>
            </div>
          </div>
          <div v-if="inputType == 'edit'">
          
            <div class="trd"  :class="{'select':groupId==item.id}" v-for="(item, index) in groupList" :key="'tr_' + index" @dblclick="inputChangeFun(item,index)" @click="textChangeFun($event,item,index)">
              <div class="td" style="width: 8rem;">
                <span>{{ index + 1 }}.</span>
              </div>
              <div class="td" style="width: 20rem;flex:1;">
                <el-input class="input1" v-model="item.name" @input="valueChange"></el-input>
              </div>
              <div class="td" style="width: 20rem;flex:1;">
                <span v-if="item.lampNames">{{ item.lampNames.split(',')[0] }} <span @click.stop="viewLamp(item, index)" class="icon_x" v-if="item.lampNames.split(',').length>1"></span></span>
 
                <div class="lamp_list_bg" v-if="item.showLamp" @click.stop="item.showLamp = false"></div>
                <div class="lamp_list scrollbar_style" v-if="item.showLamp">
                  <div class="li" v-for="(name,i) in item.lampNames.split(',')" :key="i+'lanpName'">{{ name }}</div>
                </div>
                <span v-if="!item.lampNames"></span>
              </div>
              <div class="td" style="width: 20rem;">
                <el-input class="input1" v-model="item.remark" @input="valueChange"></el-input>
              </div>
              <div class="td" style="width: 20rem;">
                <span class="btn" style="margin-right: 1rem;" @click="groupDel(item)">{{ $t('App.delete') }}</span>
                <span class="btn" @click="inputChangeFun(item,index,'btn')">{{ $t('App.groupSetting.text8') }}</span>
              </div>
              <span v-if="!item.lampIds" style="position: absolute;font-size: 1rem;color: red;right: 1rem;bottom: 0rem;line-height: initial;">{{ $t('App.groupSetting.text5') }}</span>
            </div>
          </div>

        </div>
      </div>
      <div class="foot_box">
        <div class="btn_box">
          <div class="btn3 icon" @click="addGroupFun"></div>
          <!-- <div class="btn1" @click="pageTypeFun">{{ $t('App.cancel') }}</div> -->
          <div class="btn1" @click="pageTypeFun">{{ $t('App.exit') }}</div>
          <div class="btn1 text" @click="edit()" v-if="inputType == 'view'">{{$t('App.edit')}}</div>
          <div class="btn1 text" @click="calcel()" v-if="inputType == 'edit'">{{$t('App.view')}}</div>
          <div class="btn2" v-loading="loading.groupAdding" @click="saveGroup" v-if="isSave">{{ $t('App.ok') }}</div>
        </div>
      </div>
    </div>

    <!-- 选择页面 -->
    <el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
      <el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_">
        <el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
      </el-radio-group>
      <span  slot="footer" class="footer">
        <el-button @click="projectSelection()">Enter</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'
export default {
  name: 'groupSetting',
  data() {
    return {
      inputType:'view',
      groupAddDevIndex_:'',
      groupList: [],
      groupList_: [],
      isSave:false,
      groupId:'',
      groupId_:-1,

      // inputTypeTime:null,

      selectVisible: false,
      getUserSettingInfoDateValue_:'systemSetting',
      getUserSettingInfoDate :{
        sysStatus:'',
        projectStatus:'',
        gatewayStatus:'',
        deviceStatus:'',
        groupStatus:'',
        sceneStatus:'',
        scheduleStatus:'',
      },

      loading:{
        groupAdding:false,
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      client_key: 'client_key',
      username: 'username',
      version: 'version',

      groupAddDev: 'groupAddDev',
      groupAddDevList: 'groupAddDevList',
      groupAddDevStr: 'groupAddDevStr',
      groupAddDevIndex: 'groupAddDevIndex',

      projectUpdate: 'projectUpdate',
      
      projectId: 'projectId',

      remRatio: 'remRatio',
      updateRemRatio: 'updateRemRatio',
      
      countryId: 'countryId',
      provinceId: 'provinceId',
      cityId: 'cityId',
      hotelId: 'hotelId',
      headerIdStr: 'headerIdStr',
      themeType: 'themeType',
      groupAddDevType:'groupAddDevType',
    }),
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy() {
    console.log('--关闭分组-')
    this.$store.commit('groupAddDevFun', {
        groupAddDev: false,
        groupAddDevList: [],
        groupAddDevStr: '',
        groupAddDevIndex: this.groupAddDevIndex+1
    })
  },
  mounted() {
    this.getUserSettingInfo();
    if(this.projectId){
      this.groupListGet();
    }
  },
  methods: {
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
    confirmSelection() {
      this.getUserSettingInfo(data => {
        if (data.isTrue) {
          this.selectVisible = true;
        }
      });
    },
    projectSelection(){
      
      this.$emit('pageTypeFun', this.getUserSettingInfoDateValue_)
      this.selectVisible = false;
    },
		//获取用户设置状态信息
		getUserSettingInfo(callback) {
			// this.selectVisible = true;
			base.ajax_post(
				allUrl.user.user_getUserSettingInfo,
				{
				username: this.username,
				version: this.version,
				token:this.token,
				},
				{},
				data => {
          this.getUserSettingInfoDate = data.data;
          data.isTrue = false;
          if(this.getUserSettingInfoDate.sysStatus == 0){
            this.getUserSettingInfoDateValue_ = 'systemSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.projectStatus == 0){
            this.getUserSettingInfoDateValue_ = 'projectSettings'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
            this.getUserSettingInfoDateValue_ = 'gatewayInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.deviceStatus == 0){
            this.getUserSettingInfoDateValue_ = 'controllerInput'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.groupStatus == 0){
            this.getUserSettingInfoDateValue_ = 'groupSetting'
            data.isTrue = true
          } else if(this.getUserSettingInfoDate.sceneStatus == 0){
            this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
            data.isTrue = true
          }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
            this.getUserSettingInfoDateValue_ = 'schedule'
            data.isTrue = true
          }
          if(callback){
            callback(data)
          }
				},
				this
			)
    },
    inputClick(){

    },
    addGroupFun(){
      this.$set(this.groupList,this.groupList.length,
        { 
          id:this.groupId_,name: '', deviceIds: '', lampAddress: '', remark: ''
        }
      )
      this.$set(this.groupList_,this.groupList_.length,
        { 
          id:this.groupId_,name: '', deviceIds: '', lampAddress: '', remark: ''
        }
      );
      this.groupId_ --;
      this.inputType = 'edit';
      // this.inputTypeTime = setTimeout(() => {
      //   this.inputType = 'view';
      // }, 10000);
    },
    pageTypeFun () {
      this.$emit('pageTypeFun', '')
    },
    edit(){
      this.inputType = 'edit';
      
      this.groupId = ''
      this.$store.commit('groupAddDevFun', {
        groupAddDevStr: '',
        groupAddDevIndex: this.groupAddDevIndex+1
      })
      // this.inputTypeTime = setTimeout(() => {
      //   this.inputType = 'view';
      // }, 10000);
    },
    calcel(){
      this.inputType = 'view';
    },
    inputChangeFun(obj,index,type) {
      if(this.inputType == 'edit'&&!type){
        return
      }
      this.groupAddDevIndex_ = index;
      this.$store.commit('groupAddDevFun', {
        groupAddDev: true,
        groupAddDevName: obj.name,
        groupAddDevRemark: obj.remark,
        groupAddDevList: [],
        groupAddDevStr: obj.lampAddress,
        groupAddDevIndex: this.groupAddDevIndex+1
      })
      console.log(this.groupAddDevStr,'--1--2--4--5')
    },
    textChangeFun(e,obj,index) {
      if(this.inputType == 'edit'){
        return
      }
      this.groupId = obj.id;
      console.log(obj.lampAddress)
      this.groupAddDevIndex_ = index;
      this.$store.commit('groupAddDevFun', {
        groupAddDevStr: obj.lampAddress,
        groupAddDevIndex: this.groupAddDevIndex+1
      })
    },
    valueChange(){
      let isSave = false;
      let groupList = JSON.parse(JSON.stringify(this.groupList));
      let groupList_ = JSON.parse(JSON.stringify(this.groupList_));
      for(let key in groupList){
        if(groupList[key].id < '0'){
          isSave = true
          continue;
        }
        if(JSON.stringify(groupList[key]) != JSON.stringify(groupList_[key])){
          isSave = true
        }
      }
      this.isSave = isSave;
      // if(this.inputTypeTime){
      //   clearTimeout(this.inputTypeTime)
      //   this.inputTypeTime = setTimeout(() => {
      //     this.inputType = 'view';
      //   }, 10000);
      // }
    },
    viewLamp(item){
      for(let obj of this.groupList){
        obj.showLamp = false
      }
      item.showLamp = true
    },
    groupDel(item,index){
      if(item.id<0){  
        this.groupList.splce(index,1)
        this.groupList_.splce(index,1)
        return
      }
      this.$confirm(
        this.$t("App.message.text3"),
        this.$t("App.message.text4"),
        {
          confirmButtonText: this.$t("App.message.text5"),
          cancelButtonText: this.$t("App.message.text6"),
          type: "warning",
        }
      )
        .then(() => {
          base.ajax_post(
            allUrl.group.group_del,
            {
              username: this.username,
              clientType: this.os,
              token: this.token,
              id: item.id,
            },
            {},
            (data) => {
              this.$message({
                showClose: true,
                message: data.msg,
                type: "success",
              });
              this.groupListGet();
            },
            this
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("App.message.text7"),
          });
        });
    },
    saveGroup(){
      // let list = [];
      let isSave = true;
      for(let d of this.groupList){
        if(!d.lampIds){
          isSave = false
        }
      }
      if(!isSave){
        this.$message({
          showClose: true,
          message: this.$t("App.groupSetting.text6"),
          type: 'warning'
        });
        return
      }
      console.log(this.groupList)
      let groupList = JSON.parse(JSON.stringify(this.groupList));
      let groupList_ = JSON.parse(JSON.stringify(this.groupList_));

      for(let key in groupList){
        if(groupList[key].id < '0'){
          this.groupAdd(groupList[key])
          continue;
        }
        // console.log(JSON.stringify(groupList[key]),JSON.stringify(groupList_[key]))
        if(JSON.stringify(groupList[key]) != JSON.stringify(groupList_[key])){
          this.groupUpdate(groupList[key])
        }
      }
      
    },
    groupAdd(obj) {
      console.log(obj)
      let d = JSON.parse(JSON.stringify(obj))
      delete d.id;
      delete d.lampAddress;
      this.loading.groupAdding = true;
      base.ajax_post(
        allUrl.group.group_add,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          ...d
        },
        {},
        data => {
          if(this.getUserSettingInfoDate.groupStatus == 0){
            this.confirmSelection()
          }
          this.$store.commit('projectUpdateFun', {
            projectUpdate: this.projectUpdate+1,
          })
          this.groupList_ = this.groupList;
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          this.loading.groupAdding = false;
          this.groupListGet();
          // console.log(this.groupList)
        },
        this, () => {
          this.loading.groupAdding = false;
        }
        // this
      )
    },
    groupUpdate(obj) {
      let d = JSON.parse(JSON.stringify(obj))
      delete d.lampAddress;
      delete d.lampIds;
      base.ajax_post(
        allUrl.group.group_update,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          ...d
        },
        {},
        data => {
          this.groupListGet()
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success'
          });
          // console.log(this.lampList)
        },
        this
      )
    },
    groupListGet() {
      base.ajax_post(
        allUrl.group.group_groupList,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId
        },
        {},
        data => {
          console.log(data,'-s-d-sd-sd-s-d-sd-s-d')
          this.groupList = [];
          for(let key in data.data){
            data.data[key].deviceIds = data.data[key].lampIds;
            data.data[key].showLamp = false;
            
            this.$set(this.groupList,key,data.data[key])
            if(this.groupId == data.data[key].id){
              this.textChangeFun(null,data.data[key],key)
            }
          }
          // this.groupList = data.data;
          this.groupList_ = JSON.parse(JSON.stringify(data.data));
          console.log(this.groupList)
        },
        this
      )
    },
    
    // linkToFun(val,data){
    // }
  },
  watch: {
    projectId:function(){
      this.groupListGet();
    },
    groupAddDev:function(){
      if(!this.groupAddDev){
        console.log(this.groupAddDevList,'-----')
        console.log(this.groupList,'--8888--')
          
        let ids = '';
        let lampAddress = '';
        for(let d of this.groupAddDevList){
          if(ids == ''){
            ids = d.id
            lampAddress = d.lampAddress
          }else{
            ids = ids+','+d.id
            lampAddress = lampAddress+','+d.lampAddress
          }
        }

        this.$set(this.groupList[this.groupAddDevIndex_],'lampAddress',lampAddress)
        this.$set(this.groupList[this.groupAddDevIndex_],'deviceIds',ids)
        this.$set(this.groupList[this.groupAddDevIndex_],'lampIds',ids)
        if(this.groupAddDevType == 'save'){
          this.saveGroup();
        }
      }
    }
  }
}
</script>

<style type="text/css" lang="less">
.groupSetting_main {
  position: absolute;
  top: 5.78rem;
  left: 0;
  width: 100%;
  height: calc(100% - 5.78rem);
  min-height: 50rem;
  margin: 0 auto;
  overflow: hidden;
  // position: relative;
  display: flex;
  justify-content: flex-end;
  // background: rgba(255, 255, 255, 0.85);
  .cont_right {
    // margin-left: auto;
    // position: absolute;
    // top: 0;
    // right: 0;
    // bottom: 0;
    .table_box {
      // width: 60rem;
      height: calc(100% - 9rem);
      background: rgba(244, 251, 253, 0.9);
      .btn{
        text-align: center;
        min-width: 9.5rem;
        padding: 0 1rem;
        height: 3.13rem;
        line-height: 3.13rem;
        background: #F4FBFD;
        border-radius: 0.2rem;
        border: 0.1rem solid #3A636F;
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3A636F;
        cursor: pointer;
      }
      .icon_x{
        display: inline-block;
        width: 1.6rem;
        height: 1.6rem;
        transform: rotateZ(90deg);
        background-image: url("../img/icon/rightArrow.png");
        background-position: center;
        background-size: 100% 100%;
        position: relative;
        top: 0.2rem;
      }
      .lamp_list_bg{
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 1001;
      }
      .lamp_list{
        position: absolute;
        width: 16rem;
        left: 27rem;
        top: 2.9rem;
        border: 0.1rem solid #3a636f;
        border-radius: 0.5rem;
        z-index: 1002;
        background: #f4fbfd;
        max-height: 20rem;
        margin: 0 0.5rem;

        .li {
          padding-left: 1.25rem;
          padding-right: 1rem;
          height: 2.5rem;
          line-height: 2.5rem;
          font-family: Calibri;
          font-weight: normal;
          font-size: 1.8rem;
          color: #3a636f;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .text {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .tr_td_box {
        height: calc(100% - 4.14rem);
        // width: calc(100% - 0.5rem);
      }

      .input1 {
        width: calc(100% - 2rem);
        height: 3.5rem;
        line-height: 3.5rem;

        .el-input__inner {
          text-align: center;
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          width: 100%;
          height: 3.5rem !important;
          line-height: 3.5rem;
          border: none;
          border-bottom: 0.09rem solid #3a636f;
          border-radius: 0;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .el-select__tags {
          .el-tag--small {
            height: 2.5rem;
            line-height: 2.5rem;
            padding: 0 0.5rem;
            max-width: 7rem;

            font-size: 1.8rem;
            font-family: Calibri;
            font-weight: normal;
            color: #3a636f;
          }
        }

        .el-select__input {
          // padding-left: 0.5rem;
          width: 100%;
          height: 3.5rem;
          line-height: 3.5rem;
          // border: 0.09rem solid #3A636F;
          // border-radius: 0.44rem;
          background-color: rgba(0, 0, 0, 0);

          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
        }

        .el-input__prefix {
          width: 1.8rem;
          height: 1.8rem;
          top: 0.96rem;
          left: 0.79rem;

          .icon {
            width: 100%;
          }
        }

        .el-input__suffix {
          height: 3.5rem;
          line-height: 3.5rem;
          right: 1.49rem;
        }

        .span {
          margin-top: -0.2rem;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          position: relative;
          top: -0.2rem;
        }

        .el-input .el-select__caret {
          font-size: 1.8rem;
          color: rgba(58, 99, 111, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .tr {
        display: flex;
        align-items: center;
        height: 4.12rem;
        line-height: 4.12rem;
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        background: rgba(244, 251, 253, 0.9);
        border-bottom: 2px solid rgba(244, 251, 253, 0.9);
        cursor: pointer;
        position: relative;
        &:nth-child(2n + 1) {
          background: rgba(255, 255, 255, 0.8);
        }
        &.select{
          // border-bottom: 2px solid #0086f9;
          background: #0086f9;
          color: #ffffff;
          
        }
        .th:nth-child(1),.td:nth-child(1){
          text-align: left;
        }
        .th,
        .td {
          text-align: center;
          height: 4.12rem;
          line-height: 4.12rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          user-select:none;
          // flex: 1;
          
        }

        .td {
          &:nth-child(1) {
            padding-left: 1rem;
          }
        }

        .th {
          &:nth-child(1) {
            padding-left: 1rem;
          }
        }

        .th_scrollbar {
          width: 0.5rem;
          height: 100%;
        }

        // .th{
        // }
        // .td{
        // }
      }
      .trd {
        display: flex;
        align-items: center;
        height: 4.12rem;
        line-height: 4.12rem;
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        background: rgba(244, 251, 253, 0.9);
        border-bottom: 2px solid rgba(244, 251, 253, 0.9);
        cursor: pointer;
        position: relative;
        &:nth-child(2n + 1) {
          background: rgba(255, 255, 255, 0.8);
        }
        // &.select{
        //   border-bottom: 2px solid #0086f9;
          
        // }
        .th:nth-child(1),.td:nth-child(1){
          text-align: left;
        }
        .th,
        .td {
          text-align: center;
          height: 4.12rem;
          line-height: 4.12rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          user-select:none;
          // flex: 1;
          
        }

        .td {
          &:nth-child(1) {
            padding-left: 1rem;
          }
        }

        .th {
          &:nth-child(1) {
            padding-left: 1rem;
          }
        }

        .th_scrollbar {
          width: 0.5rem;
          height: 100%;
        }

        // .th{
        // }
        // .td{
        // }
      }
    }
    .foot_box{
      height: 9rem;
      background: rgba(244, 251, 253, 0.9);
      // padding-left: 30rem;
      display: flex;
      justify-content: flex-end;
      .btn_box{
        display: flex;
        align-items: center;
      }
      .btn1{
        text-align: center;
        min-width: 7.5rem;
        padding: 0 1rem;
        height: 3.13rem;
        line-height: 3.13rem;
        background: #F4FBFD;
        border-radius: 0.2rem;
        border: 0.1rem solid #3A636F;
        
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3A636F;
        margin-right: 2rem;
        cursor: pointer;
      }
      .btn2{
        text-align: center;
        min-width: 7rem;
        padding: 0 1rem;
        height: 3.13rem;
        line-height: 3.13rem;
        background: #F4FBFD;
        border-radius: 0.2rem;
        border: 0.1rem solid #00C6FF;
        
        background: #00C6FF;

        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #FFFFFF;
        margin-right: 2rem;
        cursor: pointer;
      }
      .btn3.icon{
        margin-right: 2rem;
        margin-left: 2rem;
        cursor: pointer;
        width: 4.28rem;
        height: 4.28rem;
        background-image: url(../img/icon/btn_bg1.png);
        background-position: center;
        background-size: 100% 100%;
      }
    }
  }
  .project_completed{
      position: fixed;
      top: 0;right: 0;left: 0;bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .bg{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0);
        z-index: -1;
        opacity: 0.5;
      }
      .form_box{
        position: relative;
        width: 36.51rem;
        height: 18.09rem;
        padding-top: 2.83rem;
        background: #FFFFFF;
        border: 0px solid #3A636F;
        border-radius: 0.2rem;
        opacity: 0.9;
        .span{
          font-family: Calibri;
          color: #3A636F;
          text-align: center;
          width: 23.22rem;
          font-weight: 400;
          font-size: 1.8rem;
          color: #4C717C;
          margin: auto;
        }
        .btn_box{
          // position: absolute;
          // bottom: 0rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 5.07rem;
          // margin: 4.47rem auto 0;
          // width: 26.69rem;
          
          .btn2{
            width: 6.25rem;
            height: 2.63rem;
            background: #00C6FF;
            border-radius: 0.2rem;

            line-height: 2.63rem;
            border: 0.09rem solid #00C6FF;
            text-align: center;

            // font-family: Calibri;
            // font-weight: normal;
            // color: #FFFFFF;
            cursor: pointer;
            user-select: none;

            font-family: Calibri;
            font-weight: 400;
            font-size: 1.8rem;
            color: #FFFFFF;
          }
        }
      }
    }
}
// .groupSetting_main.themeType_1 {
//   .cont_right {
//     .table_box {
//       background: rgba(250,  237, 218, 0.9);
//       .btn{
//         background: #f2cd9b;
//         border: 0.1rem solid #682411;
//         color: #682411;
//       }
//       .icon_x{
//         background-image: url("../img/orange/rightArrow.png");
//       }
//       .lamp_list{
//         border: 0.1rem solid #682411;
//         // background: rgba(250, 237, 218, 0.9);
//         .li {
//           color: #682411;
//         }
//       }
//       .input1 {
//         .el-input__inner {
//           border: 0.09rem solid #682411;
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//         .el-select__tags {
//           .el-tag--small {
//             color: #682411;
//           }
//         }
//         .el-select__input {
//           background-color: rgba(0, 0, 0, 0);
//           color: #682411;
//         }
//         .span {
//           color: #682411;
//         }
//         .el-input .el-select__caret {
//           color: #682411;
//         }
//       }
//       .tr {
//         color: #682411;
//         // background: rgba(250, 237, 218, 0.9);
//         background: none;
//         border-bottom: 2px solid rgba(250, 237, 218, 0.9);
//         &:nth-child(2n + 1) {
//           background: rgba(250, 237, 218, 0.9);
//         }
//         &.select{
//           background: #fdbe6e;
//           color: #ffffff;
//         }
//       }
//       .trd {
//         color: #682411;
//         background: none;
//         border-bottom: 2px solid rgba(250, 237, 218, 0.9);
//         &:nth-child(2n + 1) {
//           background: rgba(250, 237, 218, 0.9);
//         }
//       }
//     }
//     .foot_box{
//       background: #faedda;
//       opacity: 0.9;
//       .btn1 {
//         background: #f2cd9b;
//         border: 0.1rem solid #682411;
//         color: #682411;
//       }
//       .btn2 {
//         background: #f44336;
//         border: 0.09rem solid #f44336;
//         color: #ffffff;
//       }
//       .btn3.icon{
//         background-image: url(../img/orange/btn_bg1.png);
//       }
//     }
//   }
//   .project_completed{
//     position: fixed;
//     top: 0;right: 0;left: 0;bottom: 0;
//     display: flex;
//     align-items: center;
//     justify-content: center;
    
//     .bg{
//       position: absolute;
//       width: 100%;
//       height: 100%;
//       background: rgba(0,0,0,0);
//       z-index: -1;
//       opacity: 0.5;
//     }
//     .form_box{
//       position: relative;
//       width: 36.51rem;
//       height: 18.09rem;
//       padding-top: 2.83rem;
//       background: #FFFFFF;
//       border: 0px solid #3A636F;
//       border-radius: 0.2rem;
//       opacity: 0.9;
//       .span{
//         font-family: Calibri;
//         color: #3A636F;
//         text-align: center;
//         width: 23.22rem;
//         font-weight: 400;
//         font-size: 1.92rem;
//         color: #4C717C;
//         margin: auto;
//       }
//       .btn_box{
//         // position: absolute;
//         // bottom: 0rem;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         margin-top: 5.07rem;
//         // margin: 4.47rem auto 0;
//         // width: 26.69rem;
        
//         .btn2{
//           width: 6.25rem;
//           height: 2.63rem;
//           background: #00C6FF;
//           border-radius: 0.2rem;

//           line-height: 2.63rem;
//           border: 0.09rem solid #00C6FF;
//           text-align: center;

//           font-size: 1.64rem;
//           // font-family: Calibri;
//           // font-weight: normal;
//           // color: #FFFFFF;
//           cursor: pointer;
//           user-select: none;

//           font-family: Calibri;
//           font-weight: 400;
//           font-size: 1.8rem;
//           color: #FFFFFF;
//         }
//       }
//     }
//   }
// }
</style>